export enum ReservationStatus {
    Active = 1,
    Administrate = 2,
    Canceled = 3,
}